
























import { Component, Vue, Watch } from 'vue-property-decorator';
import Customer from '@/models/customerModel';
import {
  FieldChildrenProp,
  GetItemsResponse,
} from '@/services/hexabase/types'
import {
  CustomerListActionButton,
  buttonItems,
  Messages,
  CustomerDefaultSort,
  sampleStatusId,
  SearchPanelColumnWidth,
  CustomerSearchDateItemlist
} from '@/constants/customer/customerList';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import SearchPanel from '@/components/common/modules/list/SearchPanel.vue';
import SearchListCheckbox from '@/components/common/modules/list/SearchListCheckbox.vue';
import hexabaseState from '@/store/hexabase';
import searchState from '@/store/search';
import BaseModel from '@/models/baseModel';
import Button from '@/components/common/elements/Button.vue';
import authState from '@/store/auth';



import ActionButtonWithSearchPanel from '@/components/common/modules/ActionButtonWithSearchPanel.vue';
import axios from 'axios';

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    SearchPanel,
    ActionButtonWithSearchPanel,
    Button,
    SearchListCheckbox
  }
})
/* eslint-disable @typescript-eslint/camelcase */
export default class DownloadFileScreen extends Vue {
  private customer = new Customer();
  private projectId = hexabaseState.applicationId;
  private isDisableDownload = true;
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  private baseModel = new BaseModel();
  private applicationId = hexabaseState.applicationId;



  private searchFieldsData: Array<FieldChildrenProp> = [];
  private mainDsId = "";
  private searchFieldCols = '5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5%';
  private apiResponseData: GetItemsResponse = { items: [], totalItems: 0 };
  private dataTableText = Messages.dataTableText;
  private token = authState.token

  private payload = {
    conditions: [] as Array<{ [key: string]: string | string[] | boolean }>,
    per_page: 0,
    page: 10,
    use_display_id: true,
    include_links: true,
    include_lookups: true,
    sort_fields: [...CustomerDefaultSort]
  };
  private page = {
    currentPage: 1,
    totalPage: 1,
    totalItem: 0,
    visible: 8,
    perPage: 10
  };
  private isFlush = false;
  private apiResult = false;
  private buttonItems = buttonItems;
  private fieldsData: any = {}
  private selectedItemsStores: Array<{ i_id: string }> = [];

  private keyMappingEnJa: { [key: string]: string } = {};

  @Watch('selectedItemsStores')
  onItemsChange(newItems: any[]) {
    this.isDisableDownload = newItems.length === 0;
  }

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      this.mainDsId = hexabaseState.datastoreIds['csv_database'];
      const fieldsData = await this.customer.getField(this.projectId, this.mainDsId);

      this.masterData = this.customer.getMaster();
      // 自動生成コンポーネント用にプロパティー設定
      this.fieldsData = fieldsData;

      const fields = this.fieldsData.fields;
      const fieldLayout = this.fieldsData.field_layout;

      const result = Object.keys(fieldLayout).map(key => {
        const field = fields[key];
        return {
          ...fieldLayout[key],
          display_id: field.display_id
        };
      });



      const fieldDetail = await this.getDetailField();
      
      const filteredFieldDetail = Object.values(fieldDetail.searchFields).filter((field: any) => !field.settings.hide_from_api);
      
      Object.values(filteredFieldDetail).forEach((field: any) => {
        const nameField = field.settings.name;
        if (nameField && nameField.en && nameField.ja) {
          this.keyMappingEnJa[nameField.en] = nameField.ja;
        }
      });

      this.searchFieldsData = this.customer.createSearchConf(this.fieldsData, this.masterData, result);
      this.searchFieldCols = `${SearchPanelColumnWidth}% `.repeat(100 / SearchPanelColumnWidth); //検索フォームは表示を均等にするため固定

      // ステータス検索が無くなった為一旦コメント
      // ステータス検索用にステータスリストをマージ
      // this.statusList = statusList;
      // const deleteStatusIndex = this.statusList[0].statuses.findIndex((status: { status_name: string; }) => status.status_name === '削除済');
      // if (deleteStatusIndex > 0) {
      //   this.statusList[0].statuses.splice(deleteStatusIndex, 1);
      // }
      // this.searchFieldsData = this.customer.setStatusBySelectProp(this.searchFieldsData, this.statusList[0].statuses);

      // 初期表示データ取得・作成
      // 検索Stateが存在していたら検索項目に値をセットする
      const stateCondition = searchState.searchCondition !== undefined ? searchState.searchCondition : [];
      for (const key in stateCondition) {
        const setConditionIndex = this.searchFieldsData.findIndex(field => field.display_id === stateCondition[key].id);
        if (setConditionIndex >= 0) {
          const dataType = this.searchFieldsData[setConditionIndex].dataType;
          switch (dataType) {
            case 'dslookup':
              this.searchFieldsData[setConditionIndex].props!.value = { item_id: stateCondition[key].search_value[0] };
              break;
            case 'status':
              this.searchFieldsData[setConditionIndex].props!.value = stateCondition[key].search_value[0];
              break;
            case 'datetime':
              this.searchFieldsData[setConditionIndex].props!.valueFrom = stateCondition[key].search_value[0];
              this.searchFieldsData[setConditionIndex].props!.valueTo = stateCondition[key].search_value[1];
              break;
            default:
              this.searchFieldsData[setConditionIndex].props!.value = stateCondition[key].search_value[0];
              break;
          }
        }
      }

      // 検索条件を与えられている場合、検索結果を取得
      if ('searchConditions' in this.$route.query) {
        await this.getItems(stateCondition);
      } else {
        this.apiResult = true;
      }


      const columnListLayout: Array<{ [k: string]: string | number }> = Object.values(filteredFieldDetail).map(item => ({
        name: (item as any).settings.name.en,
        text: (item as any).settings.name.ja,
        value: (item as any).settings.display_id,
        order: (item as any).order,
        width: 200
      }));


      // 一覧カラム設定
      this.colums = this.customer.createColumns(columnListLayout, this.fieldsData.fields);
      this.colums.map(v => { if (v.name === sampleStatusId) { v.text = 'ステータス' } return v; });

      this.updateSearchFieldsLabel();


    } catch (e) {
      console.log(e);
    }
    finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  private updateSearchFieldsLabel() {
    this.searchFieldsData.forEach(field => {
      if (this.keyMappingEnJa[field.name]) {
        if (field.props) {
          field.props.labelText = this.keyMappingEnJa[field.name];
        }
      }
    });
  }

  async getItems(condition?: Array<{ [key: string]: string[] }>, page?: number) {
    // Fetch data from API
    try {
      this.$store.commit('hexabase/setIsLoading', true);

      if (condition !== undefined && condition.length > 0) {
        for (const key in searchState.searchCondition) {
          const findData = condition.find(recode => recode.id === searchState.searchCondition![key].id);
          if (!findData) {
            condition.push(searchState.searchCondition[key]);
          } else {
            const setConditionIndex = this.searchFieldsData.findIndex(field => field.display_id === searchState.searchCondition[key].id);
            if (setConditionIndex >= 0) {
              const componentType = this.searchFieldsData[setConditionIndex].component;
              switch (componentType) {
                case 'DatePickerRangeArea':
                  if (searchState.searchCondition[key].search_value[0] && !findData.search_value[0]) {
                    findData.search_value[0] = searchState.searchCondition[key].search_value[0];
                  }
                  if (searchState.searchCondition[key].search_value[1] && !findData.search_value[1]) {
                    findData.search_value[1] = searchState.searchCondition[key].search_value[1];
                  }
                  break;
                default:
                  break;
              }
            }
          }
        }
        searchState.setConditions(condition);
      }

      this.payload = {
        "conditions": [],
        "per_page": 0, //select all
        "page": 1,
        "use_display_id": true,
        "include_links": true,
        "include_lookups": true,
        "sort_fields": [
          {
            "id": "KOMONSAKICODE",
            "order": "asc"
          }
        ]
      }


      this.payload['page'] = page !== undefined ? page : 1;
      if (condition !== undefined) {
        this.payload['conditions'] = condition.concat();
      } else {
        this.payload['conditions'] = searchState.searchCondition.concat();
      }
      this.apiResponseData = await this.customer.getItemSearch(this.projectId, this.mainDsId, this.payload);
      if (this.apiResponseData.errors !== undefined) {
        this.dataTableText = this.customer.getErrMessage('ITEMLIST', this.apiResponseData);
      } else if (this.apiResponseData.items.length === 0) {
        this.dataTableText = this.customer.getMessage('ITEMLIST', 'NOT_FOUND');
      }

      this.page.perPage = this.apiResponseData.totalItems;

    } catch (e) {
      console.log(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
      this.apiResult = true;
    }

    for (const key in this.apiResponseData.items) {
      // 定義ファイルで指定した日付の表示形式変更
      for (const index in CustomerSearchDateItemlist) {
        if (
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]] !== undefined &&
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]] !== null &&
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]].length > 0
        ) {
          const date = this.apiResponseData.items[key][CustomerSearchDateItemlist[index]];
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]] = this.customer.editDatetype(date, 'Asia/Tokyo', '');
        }
      }
    }

    // アイテム数等をセット
    this.page.totalItem = this.apiResponseData.totalItems, 0;
    this.page.totalPage = this.customer.getTotalPage(this.apiResponseData.totalItems, 0);
    this.page.currentPage = this.payload['page'];
  }
  private colums: Array<{ [k: string]: string | number }> = [];

  private resetSearchForm(): void {
    this.payload.conditions.splice(0);
    this.payload.page = 1;
  }

  private clickButton(response: { [k: string]: any }) {
    switch (response.buttonName) {
      case 'detail': {
        this.$router.push({ name: 'TemplateScreen', params: { id: response.record.i_id } });
        break;
      }
    }
  }

  private pageNaviAction(response: number) {
    this.page.currentPage = response;
    this.getItems(undefined, response);
  }

  private selectItemHandle(selectItems: any) {
    this.selectedItemsStores = selectItems;
  }

  private async exportCsv() {
    // const convertedItem = this.convertToCSV(this.selectedItemsStores);
    const itemSelectedIds = this.selectedItemsStores.map(item => item.i_id);
    const convertedItem = await this.getCsvData(itemSelectedIds);

    const convertedKeyItems = this.convertKeys(convertedItem, this.keyMappingEnJa);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const dateStr = `${year}${month}${day}`;
    
    const fileName = `帳票_${dateStr}`;
    this.baseModel.formOutPutDownloadJaText(convertedKeyItems, fileName, 'csv');

  }

  private convertToCSV(items: any[]): string {
    if (items.length === 0) {
      return '';
    }

    const excludedKeys = ['id', 'd_id', 'i_id', 'item_links', 'p_id', 'rev_no', 'status_id', 'title', 'unread', 'created_at', 'created_by'];
    const keys = Object.keys(items[0]).filter(key => !excludedKeys.includes(key));
    const header = keys.join(',');

    const rows = items.map(item => {
      return keys.map(key => {
        let value = item[key];
        if (typeof value === 'object' && value !== null) {
          value = JSON.stringify(value);
          value = value.toString().replace(/,/g, ' ');
        }
        return `"${value}"`;
      }).join(',');
    });

    return [header, ...rows].join('\n');
  }

  private async getCsvData(listItems: string[]): Promise<any> {
    const payloadGetCsv = {
      "conditions": [
        {
          "id": "i_id",
          "search_value": listItems,
          "exact_match": true
        }
      ],
      "per_page": 0, //select all
      "page": 1,
      "use_display_id": true,
      "include_links": false,
      "include_lookups": false,
      "return_number_value": false,
      "format": "csv"
    }

    try {
      const response = await axios.post(`https://api.hexabase.com/api/v0/applications/${this.applicationId}/datastores/${this.mainDsId}/items/search`, payloadGetCsv, {
        headers: {
          'Authorization': `Bearer ${this.token}`,
        },
      });

      if (response.status === 200) {
        return response.data
      } else {
        return "";
      }
    }
    catch (error) {
      console.error(error);
      return "";
    }
  }


  private async getDetailField(): Promise<any> {


    try {

      const response = await axios.get(`https://app.hexabase.com/v1/api/get_datastore_search_fields?datastoreID=${this.mainDsId}`, {
        headers: {
          'Authorization': `Bearer ${this.token}`,
        },
      });

      if (response.status === 200) {
        return response.data
      } else {
        return "";
      }
    }
    catch (error) {
      console.error(error);
      return "";
    }
  }

  private convertKeys(csvData: string, keyMapping: { [key: string]: string }): string {
    const lines = csvData.split('\n');
    if (lines.length === 0) {
      return csvData;
    }

    const headers = lines[0].split(',');
    const newHeaders = headers.map(header => keyMapping[header] || header);
    lines[0] = newHeaders.join(',');

    return lines.join('\n');
  }
}
